<template>
    <div>
        <h1 class="title is-1">{{ $t('menu.gallery') }}</h1>
        <b-tabs v-model="currentTab" position="is-centered" size="is-large" type="is-boxed" class="block" @input="changeTab" expanded>
            <b-tab-item :label="$t('school')">
                <div v-if="isLoading">

                </div>
                <div
                    v-else-if="schoolGallery !== null">
                    <div 
                        v-for="(galleryArray, schoolIndex) in schoolGallery"
                        v-bind:key="schoolIndex">
                        <div v-if="typeof galleryArray.elements === 'undefined'">
                            <h2 @click="toogleYear(schoolIndex, 'school')">
                                <b-icon :icon="choosenYear == schoolIndex ? 'chevron-down' : 'chevron-right'"></b-icon> 
                                <u>{{schoolIndex}}</u>
                            </h2>

                            <div v-if="choosenYear == schoolIndex">
                                <ul v-for="(gallery, schoolGalleryIndex) in galleryArray"
                                    v-bind:key="schoolGalleryIndex">
                                    <li @click="openModal(schoolGalleryIndex, gallery)">
                                        <b-icon icon="subdirectory-arrow-right"></b-icon> <u>{{gallery.name[$i18n.locale]}}</u> ({{gallery.elements.length}})
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-else>
                            <b-icon icon="arrow-right"></b-icon> <u @click="openModal(schoolIndex, galleryArray)">{{galleryArray.name[$i18n.locale]}}</u> ({{galleryArray.elements.length}})
                        </div>
                        
                    </div>
                </div>
                <div v-else>
                    <h3 class="title is-3">
                        {{ $t("messages.uploadProcess") }}
                    </h3>
                </div>
            </b-tab-item>

            <b-tab-item :label="$t('nursery')">
                <div v-if="isLoading">

                </div>
                <div
                    v-else-if="nurseryGallery !== null">
                    <div 
                        v-for="(galleryArray, nurseryIndex) in nurseryGallery"
                        v-bind:key="nurseryIndex">
                        <div v-if="typeof galleryArray.elements === 'undefined'">
                            <h2 @click="toogleYear(nurseryIndex, 'nursery')">
                                <b-icon :icon="choosenYear == nurseryIndex ? 'chevron-down' : 'chevron-right'"></b-icon> 
                                <u>{{nurseryIndex}}</u>
                            </h2>

                            <div v-if="choosenYear == nurseryIndex">
                                <ul v-for="(gallery, nurseryGalleryIndex) in galleryArray"
                                    v-bind:key="nurseryGalleryIndex">
                                    <li @click="openModal(nurseryGalleryIndex, gallery)">
                                        <b-icon icon="subdirectory-arrow-right"></b-icon> <u>{{gallery.name[$i18n.locale]}}</u> ({{gallery.elements.length}})
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-else>
                            <b-icon icon="arrow-right"></b-icon> <u @click="openModal(nurseryIndex, galleryArray)">{{galleryArray.name[$i18n.locale]}}</u> ({{galleryArray.elements.length}})
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h3 class="title is-3">
                        {{ $t("messages.uploadProcess") }}
                    </h3>
                </div>
                
            </b-tab-item>
        </b-tabs>
        
    </div>
</template>
<script>
    import axios from 'axios'
    import EventBus from '../event-bus.js'
    
    export default {
        data(){
            return {
                isLoading: true,
                currentTab: null,
                choosenYear: null,
                schoolGallery: null,
                nurseryGallery: null
            }
        },
        methods: {
            changeTab(){
                this.choosenYear = null
                this.$router.push({ name: 'galleryType', params: { galleryType: this.currentTab } })
            },
            toogleYear(year){
                this.choosenYear = null
                if(year == this.choosenYear){
                    this.$router.push({ name: 'galleryType', params: { galleryType: this.currentTab } })                    
                } else {
                    this.choosenYear = year
                    this.$router.push({ name: 'galleryYear', params: { galleryType: this.currentTab, year: this.choosenYear } })
                }
            },
            openModal(index, gallery){
                EventBus.$emit('openGalleryModal', gallery)
                var year = 0
                if(gallery.parent !== 'school' && gallery.parent !== 'nursery'){
                    year = gallery.parent
                } else {
                    year = 0
                }
                this.$router.push({ name: 'galleryInstance', params: { galleryType: this.currentTab, year: year, gallery: index } })
            },
            getData(){
                axios.get("/gallery.json")
                .then(response => {
                    this.isLoading = true
                    this.schoolGallery = response.data.school
                    this.nurseryGallery = response.data.nursery
                    this.initialize()
                    this.isLoading = false
                })
            },
            initialize(){
                if(this.$route.name == 'gallery' || this.$route.name == 'gallery'){
                    this.currentTab = 0
                    this.$router.push({ name: 'galleryType', params: { galleryType: this.currentTab } })
                } else if(this.$route.name == 'galleryType'){
                    this.currentTab = parseInt(this.$route.params.galleryType)
                } else if(this.$route.name == 'galleryYear'){
                    this.currentTab = parseInt(this.$route.params.galleryType)
                    this.toogleYear(this.$route.params.year, this.currentTab)
                } else if(this.$route.name == 'galleryInstance'){
                    this.currentTab = parseInt(this.$route.params.galleryType)
                    this.choosenYear = this.$route.params.year
                    var year = this.$route.params.year
                    var index = this.$route.params.gallery
                    switch(this.currentTab){
                        case 0:
                            if(year > 0){
                                this.openModal(index, this.schoolGallery[this.$route.params.year][this.$route.params.gallery])
                            } else {
                                this.openModal(index, this.schoolGallery[this.$route.params.gallery])
                            }
                        break

                        case 1:
                            if(year > 0){
                                this.openModal(index, this.nurseryGallery[this.$route.params.year][this.$route.params.gallery])
                            } else {
                                this.openModal(index, this.nurseryGallery[this.$route.params.gallery])
                            }
                        break
                    }                    
                }
            }
        },
        created(){
            this.getData()
        }
    }
</script>